import * as o from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/XLogo.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...r, weights: m }));
e.displayName = "XLogoIcon";
const n = e;
export {
  n as XLogo,
  e as XLogoIcon
};
